import Svg, { Mask, Path, G } from "react-native-svg";

export default function Multientrega({ scale = 1 }: { scale?: number }) {
  const width = 175 * scale;
  const height = 20 * scale;

  return (
    <Svg width={width} height={height} fill="none" viewBox="0 0 175 20">
      <Mask
        id="a"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#a)">
        <Path
          fill="#26336D"
          d="M135.97 8.242h-1.581c.591-3.585 2.718-5.566 6.376-5.947 1.976-.204 3.757.234 5.34 1.316.085.06.092.126.02.2l-.871.879c-.058.057-.122.066-.191.024-3.458-2.025-8.285-.872-9.093 3.528Z"
        />
      </G>
      <Mask
        id="b"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#26336D"
          d="M155.658 8.242h-2.4l-2.037-2.31a.05.05 0 0 0-.088.034l-.002 2.276-1.662.004.068-5.654c.002-.086.043-.139.126-.16.415-.106.781.03 1.102.409.894 1.063 2.526 2.863 4.893 5.4Z"
        />
      </G>
      <Mask
        id="c"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#c)">
        <Path
          fill="#26336D"
          d="M38.842 14.196h7.585c.059 0 .106.048.106.108v1.325c0 .059-.047.107-.106.107h-9.221a.108.108 0 0 1-.107-.107v-13.1c0-.06.048-.108.107-.108h1.422c.059 0 .107.048.107.107v11.56c0 .06.048.108.107.108Z"
        />
      </G>
      <Mask
        id="d"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#d)">
        <Path
          fill="#26336D"
          d="M61.912 15.622c0 .064-.05.114-.113.114h-1.357a.113.113 0 0 1-.114-.114V2.535c0-.064.05-.114.114-.114h1.357c.063 0 .113.05.113.114v13.087Z"
        />
      </G>
      <Mask
        id="e"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#e)">
        <Path
          fill="#26336D"
          d="M67.298 14.14h8.534c.052 0 .096.045.096.098v1.402a.097.097 0 0 1-.096.096H65.717a.097.097 0 0 1-.096-.097V2.518c0-.053.043-.097.096-.097h9.897c.052 0 .096.044.096.097v1.346a.097.097 0 0 1-.096.097h-8.316a.097.097 0 0 0-.096.097v4.704c0 .052.044.096.096.096h6.734c.052 0 .096.044.096.097v1.347a.097.097 0 0 1-.096.097h-6.734a.097.097 0 0 0-.096.097v3.548c0 .053.044.097.096.097Z"
        />
      </G>
      <Mask
        id="f"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#f)">
        <Path
          fill="#26336D"
          d="M81 6.061v9.565c0 .073-.038.11-.11.11h-1.335c-.091 0-.137-.046-.137-.136V2.595c0-.058.026-.097.078-.117.389-.156.696-.108.923.143 2.888 3.211 5.779 6.427 8.671 9.647.033.037.094.013.094-.038l-.007-9.67c0-.093.046-.14.138-.14h1.31c.09 0 .136.047.136.14v13.038c0 .092-.046.138-.137.138h-.565a.286.286 0 0 1-.223-.099l-8.695-9.631C81.047 5.9 81 5.918 81 6.061Z"
        />
      </G>
      <Mask
        id="g"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#g)">
        <Path
          fill="#26336D"
          d="m109.314 4.102-.022 5.859c0 .086.07.156.155.156l4.664.016c1.706.006 3.091-1.35 3.097-3.031v-.088c.007-1.68-1.372-3.046-3.075-3.053l-4.664-.015a.155.155 0 0 0-.155.156Zm5.685 7.589 4.561 3.878c.133.112.113.167-.059.167h-1.902a.296.296 0 0 1-.197-.072l-4.587-3.927a.293.293 0 0 0-.196-.072h-3.207c-.072 0-.109.037-.109.11v3.796c0 .11-.055.165-.164.165h-1.308c-.072 0-.11-.037-.11-.11v-13.1c0-.057.046-.103.101-.103 2.14-.011 4.286 0 6.439.035 5.635.092 6.42 8.179.781 9.075-.128.02-.144.072-.043.158Z"
        />
      </G>
      <Mask
        id="h"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#h)">
        <Path
          fill="#26336D"
          d="M123.425 14.14h8.512c.059 0 .107.049.107.108v1.38c0 .06-.048.108-.107.108h-10.093a.108.108 0 0 1-.107-.107v-13.1c0-.06.048-.108.107-.108h9.875c.059 0 .107.048.107.107v1.325c0 .06-.048.108-.107.108h-8.294a.108.108 0 0 0-.107.108v9.964c0 .06.048.108.107.108Z"
        />
      </G>
      <Mask
        id="i"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#i)">
        <Path
          fill="#26336D"
          d="M52.641 4.076v11.546c0 .064-.05.114-.113.114h-1.355a.113.113 0 0 1-.113-.114V4.076a.113.113 0 0 0-.114-.115h-4.79a.113.113 0 0 1-.113-.114V2.59c0-.064.05-.114.113-.114h11.39c.062 0 .113.05.113.114v1.257c0 .064-.05.114-.114.114h-4.79a.113.113 0 0 0-.114.115Z"
        />
      </G>
      <Mask
        id="j"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#j)">
        <Path
          fill="#26336D"
          d="M100.032 4.087V15.61a.126.126 0 0 1-.124.125H98.52a.126.126 0 0 1-.124-.125V4.087a.126.126 0 0 0-.124-.126h-4.333a.126.126 0 0 1-.124-.125V2.6c0-.068.057-.125.124-.125h10.55c.067 0 .124.057.124.125v1.235a.126.126 0 0 1-.124.125h-4.333a.126.126 0 0 0-.124.126Z"
        />
      </G>
      <Mask
        id="k"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#k)">
        <Path
          fill="#26336D"
          d="M24.024 10.178c.013 5.524 7.942 5.392 7.947.057.002-2.515.002-5.033.002-7.549 0-.103.05-.154.152-.154h1.276c.1 0 .151.05.151.152.004 1.882.004 3.761.002 5.639-.002 1.996-.118 3.328-.342 3.994-1.874 5.536-10.757 4.255-10.776-1.919-.01-2.568-.011-5.141-.005-7.714 0-.101.05-.152.15-.152h1.277c.098 0 .148.05.15.152.003 2.502.01 5 .016 7.494Z"
        />
      </G>
      <Mask
        id="l"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#l)">
        <Path
          fill="#26336D"
          d="m17.663 5.423-4.677 6.871a.353.353 0 0 1-.15.125c-.37.161-.629.133-.777-.085A1418.743 1418.743 0 0 0 7.382 5.52a.062.062 0 0 0-.114.035v10.124c0 .073-.037.11-.109.11H5.822c-.09 0-.135-.046-.135-.139V2.777c0-.092.046-.139.135-.139h1.394a.24.24 0 0 1 .212.115l4.978 7.646c.041.062.13.06.17-.002l4.927-7.662a.203.203 0 0 1 .18-.097h1.5c.092 0 .138.047.138.137v12.878c0 .09-.046.136-.138.136h-1.28c-.11 0-.164-.055-.164-.165V5.447c0-.042-.052-.06-.076-.024Z"
        />
      </G>
      <Mask
        id="m"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#m)">
        <Path
          fill="#DF3D29"
          d="m157.494 10.308-2.382-.01h-20.723l-9.847-.007a.078.078 0 0 1-.076-.077l-.002-1.847c0-.077.037-.116.113-.116l9.812-.007h1.581l13.499.004 1.662-.004h14.62c.085.002.098-.029.037-.09l-3.423-3.45c-.054-.054-.054-.11 0-.164l1.05-1.061c.063-.064.128-.064.192 0l5.643 5.696c.063.064.063.128 0 .191l-5.672 5.723c-.063.064-.126.064-.19 0l-1.09-1.1c-.046-.047-.046-.09 0-.137l3.435-3.467c.035-.035.009-.096-.041-.096l-8.198.02Z"
        />
      </G>
      <Mask
        id="n"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#n)">
        <Path
          fill="#26336D"
          d="M134.389 10.297h1.581c.757 4.47 6.636 5.118 9.655 2.668a.217.217 0 0 0 .088-.185l-.035-2.483h1.581v3.069a.259.259 0 0 1-.072.184c-2.111 2.237-4.982 2.785-7.912 2.109-2.833-.654-4.463-2.44-4.886-5.362Z"
        />
      </G>
      <Mask
        id="o"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#o)">
        <Path
          fill="#26336D"
          d="M149.55 10.298h1.581l-.006 5.324c0 .077-.037.114-.114.114h-1.341c-.077 0-.114-.037-.116-.114l-.004-5.324Z"
        />
      </G>
      <Mask
        id="p"
        width={175}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M0 .643h175v18.716H0V.643Z" />
      </Mask>
      <G mask="url(#p)">
        <Path
          fill="#26336D"
          d="m155.112 10.298 2.382.01 4.568 5.332c.033.037.004.094-.044.094l-1.834.002a.283.283 0 0 1-.218-.094l-4.854-5.344Z"
        />
      </G>
    </Svg>
  );
}
